import { useSelector } from "react-redux";
import "./UwProductHome.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { GridLoader } from "react-spinners";
import { motion } from "framer-motion";
import RefreshIcon from "@mui/icons-material/Refresh";
import { FiSearch } from "react-icons/fi";
import { CustomLoadingButton } from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import AddIcon from "@mui/icons-material/Add";
import { MdArrowBackIos, MdClose } from "react-icons/md";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy";
import { useTranslation } from "react-i18next";


const UwProductHome = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [productsData, setProductsData] = useState([]);
  const showBack = location.state?.showBack || "N";


  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/uwProduct/findAll");
      // console.log(`fetchProducts ${JSON.stringify(res.data, null, 2)}`);
      setProductsData(res.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    const filteredResults = productsData?.filter(
      (item) =>
        item.pr_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.pr_code?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filteredResults);
  }, [productsData, searchTerm]);

  return (
    <motion.div
      className="products-home"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="navbar">
        <div className="navbar-left">
          {/* Search */}
          <div className="homeSearch">
            <FiSearch className="homeSearchIcon" />
            <input
              className="homeSearchInput"
              type="text"
              placeholder={t('search')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm?.length > 0 ? (
              <MdClose
                className="homeSearchClear"
                onClick={() => setSearchTerm("")}
              />
            ) : (
              <span className="homeSearchClearPlaceholder" />
            )}
          </div>
          {searchTerm.length > 0 && <h2 className="sub-title soft" style={{ marginLeft: "10px", fontSize: "10px" }}>{`${t('found').toUpperCase()} ${filteredData.length} ${t('products').toUpperCase()}`}</h2>}
          {searchTerm.length === 0 && <h2 className="sub-title soft" style={{ marginLeft: "10px", fontSize: "10px" }}>{`${filteredData.length} ${t('products').toUpperCase()}`}</h2>}
        </div>
        <div className="navbar-right">
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#0f766e5d"
            tooltip={"Refresh products list"}
            endIcon={<RefreshIcon />} onClick={fetchProducts}>
            {t('refresh')}
          </CustomLoadingButton>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#0ea5a4"
            tooltip={"Add new product"}
            endIcon={<AddIcon />}
            onClick={() => navigate("/product/new")}
          >
            {t('newProduct')}
          </CustomLoadingButton>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>}
        </div>
      </div>
      <div className="product-content">
        {isLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              width: "100%",
              height: "100%",
            }}
          >
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        ) : (
          <div className="products-wrapper">
            {filteredData?.map((product) => (
              <div
                className="single-product"
                key={product._id}
                onClick={() => {
                  try {
                    navigate(`/product/${product._id}`, {
                      state: product,
                    });
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                <div className="product-title-row">
                  <h2 className="sub-title two-lines">{product?.pr_name}</h2>
                  <h3 className="product-name">{product?.pr_code}</h3>
                </div>
                <div className="user-wrapper">
                  <WorkedOnBy name={product?.updated_by_name_xx} photoUrl={product?.updated_by_photo_url_xx} time_ago_xx={product?.time_ago_xx} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default UwProductHome;
